<template>
    <tr>
        <td
            v-for="(header, index) of headers"
            :key="index"
            :style="{ padding: `${rowPaddingPx}px` }"
        >
            <v-row
                no-gutters
                v-if="index === 0 && !hideName"
                @click="onNameClicked(props.item)"
                style="cursor: pointer"
            >
                <v-col cols="12" class="font-weight-medium pl-1">
                    {{ props.item.name }}
                </v-col>
            </v-row>
            <!-- When the name is hidden, colums are shifted left by 1 -->
            <v-row v-else-if="showFECInfo && index === (hideName ? 0 : 1)" no-gutters>
                <v-col cols="12" class="font-weight-medium pl-1 d-flex justify-center">
                    <v-icon :color="getFECColor(props.item)" size="small">
                        {{ getFECStatus(props.item) }}
                    </v-icon>
                </v-col>
            </v-row>
            <v-row
                no-gutters
                v-else-if="options.length === 4"
                class="rounded"
                style="overflow: hidden; cursor: pointer; width: 50px; margin: auto"
            >
                <v-col cols="6" class="ma-0 d-flex justify-center" v-if="optionContain('EXPENSE')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'EXPENSE', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'PURCHASE_INVOICE', header.value)"
                        :data-cy="
                            header.value + '-AccountingClientMonitoring-caseHG-' + props.index
                        "
                        v-tooltip:bottom="
                            '(' +
                            getNumber('EXPENSE', header.value) +
                            ') - ' +
                            $t('document.type.PURCHASES')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'EXPENSE', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >A</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>{{
                            "(" +
                            getNumber("EXPENSE", header.value) +
                            ") - " +
                            $t("document.type.PURCHASES")
                        }}</span>
                    </v-tooltip> -->
                </v-col>
                <v-col cols="6" class="ma-0 d-flex justify-center" v-if="optionContain('SALES')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'SALES', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'SALES', header.value)"
                        :data-cy="'AccountingClientMonitoring-caseHD-' + props.index"
                        v-tooltip:bottom="
                            '(' +
                            getNumber('SALES', header.value) +
                            ') - ' +
                            $t('document.type.SALES')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'SALES', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >V</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>
                            {{
                                "(" +
                                getNumber("SALES", header.value) +
                                ") - " +
                                $t("document.type.SALES")
                            }}</span
                        >
                    </v-tooltip> -->
                </v-col>
                <v-col cols="6" class="ma-0 d-flex justify-center" v-if="optionContain('PAY_SLIP')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'PAY_SLIP', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'PAY_SLIP', header.value)"
                        :data-cy="'AccountingClientMonitoring-caseBG-' + props.index"
                        v-tooltip:bottom="
                            '(' +
                            getNumber('PAY_SLIP', header.value) +
                            ') - ' +
                            $t('document.type.PAY_SLIP')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'PAY_SLIP', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >P</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>{{
                            "(" +
                            getNumber("PAY_SLIP", header.value) +
                            ") - " +
                            $t("document.type.PAY_SLIP")
                        }}</span>
                    </v-tooltip> -->
                </v-col>
                <v-col class="ma-0 d-flex justify-center" v-if="optionContain('BANK_TRANSACTION')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'BANK_TRANSACTION', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'BANK_TRANSACTION', header.value)"
                        :data-cy="'AccountingClientMonitoring-caseBD-' + props.index"
                        v-tooltip:bottom="
                            '(' +
                            getNumber('BANK_TRANSACTION', header.value) +
                            ') - ' +
                            $t('document.type.BANK_TRANSACTION')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'BANK_TRANSACTION', header.value) === white
                                    ? 'text-light-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >B</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>{{
                            "(" +
                            getNumber("BANK_TRANSACTION", header.value) +
                            ") - " +
                            $t("document.type.BANK_TRANSACTION")
                        }}</span>
                    </v-tooltip> -->
                </v-col>
            </v-row>
            <v-row
                no-gutters
                v-else-if="options.length === 5"
                class="rounded"
                style="overflow: hidden; cursor: pointer; width: 75px; margin: auto"
            >
                <v-col cols="4" class="ma-0 d-flex justify-center" v-if="optionContain('EXPENSE')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'EXPENSE', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'PURCHASE_INVOICE', header.value)"
                        v-tooltip:bottom="
                            '(' +
                            getNumber('EXPENSE', header.value) +
                            ') - ' +
                            $t('document.type.PURCHASES')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'EXPENSE', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >A</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>{{
                            "(" +
                            getNumber("EXPENSE", header.value) +
                            ") - " +
                            $t("document.type.PURCHASES")
                        }}</span>
                    </v-tooltip> -->
                </v-col>
                <v-col cols="4" class="ma-0 d-flex justify-center" v-if="optionContain('SALES')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'SALES', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'SALES', header.value)"
                        v-tooltip:bottom="
                            '(' +
                            getNumber('SALES', header.value) +
                            ') - ' +
                            $t('document.type.SALES')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'SALES', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >V</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>{{
                            "(" +
                            getNumber("SALES", header.value) +
                            ") - " +
                            $t("document.type.SALES")
                        }}</span>
                    </v-tooltip> -->
                </v-col>
                <v-col cols="4" class="ma-0 d-flex justify-center" v-if="optionContain('PAY_SLIP')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'PAY_SLIP', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'PAY_SLIP', header.value)"
                        v-tooltip:bottom="
                            '(' +
                            getNumber('PAY_SLIP', header.value) +
                            ') - ' +
                            $t('document.type.PAY_SLIP')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'PAY_SLIP', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >P</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>{{
                            "(" +
                            getNumber("PAY_SLIP", header.value) +
                            ") - " +
                            $t("document.type.PAY_SLIP")
                        }}</span>
                    </v-tooltip> -->
                </v-col>
                <!-- <v-col
                    cols="6"
                    class="ma-0 d-flex justify-center"
                    v-if="optionContain('VAT')"
                >
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-avatar
                                tile
                                :color="
                                    getColor(props.item, 'VAT', header.value)
                                "
                                size="25"
                                class="pa-0 ma-0 avatarHover"
                                style="width: 37.5px"
                                @click="
                                    getClick(props.item, 'VAT', header.value)
                                "
                                v-on="on"
                                v-bind="attrs"
                            >
                                <span
                                    :class="
                                        getColor(
                                            props.item,
                                            'VAT',
                                            header.value
                                        ) === white
                                            ? 'grey--text font-weight-bold'
                                            : 'white--text font-weight-bold'
                                    "
                                    >T</span
                                >
                            </v-avatar>
                        </template>
                        <span>{{
                            "(" +
                            getNumber("VAT", header.value) +
                            ") - " +
                            $t("document.type.VAT")
                        }}</span>
                    </v-tooltip>
                </v-col> -->
                <v-col
                    cols="6"
                    class="ma-0 d-flex justify-center"
                    v-if="optionContain('BANK_TRANSACTION')"
                >
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'BANK_TRANSACTION', header.value)"
                        size="25"
                        style="width: 37.5px"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'BANK_TRANSACTION', header.value)"
                        v-tooltip:bottom="
                            '(' +
                            getNumber('BANK_TRANSACTION', header.value) +
                            ') - ' +
                            $t('document.type.BANK_TRANSACTION')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'BANK_TRANSACTION', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >B</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>{{
                            "(" +
                            getNumber("BANK_TRANSACTION", header.value) +
                            ") - " +
                            $t("document.type.BANK_TRANSACTION")
                        }}</span>
                    </v-tooltip> -->
                </v-col>
            </v-row>
            <v-row
                no-gutters
                v-else
                class="rounded"
                style="overflow: hidden; cursor: pointer; width: fit-content; margin: auto"
            >
                <v-col class="ma-0 d-flex justify-center" v-if="optionContain('EXPENSE')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'EXPENSE', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'EXPENSE', header.value)"
                        v-tooltip:bottom="
                            '(' +
                            getNumber('EXPENSE', header.value) +
                            ') - ' +
                            $t('document.type.PURCHASES')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'PURCHASE_INVOICE', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >A</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>{{
                            "(" +
                            getNumber("EXPENSE", header.value) +
                            ") - " +
                            $t("document.type.PURCHASES")
                        }}</span>
                    </v-tooltip> -->
                </v-col>
                <v-col
                    class="ma-0 d-flex justify-center"
                    v-if="optionContain('SALES') || optionContain('ZTILL_RECEIPT')"
                >
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'SALES', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'SALES', header.value)"
                        v-tooltip:bottom="
                            '(' +
                            getNumber('SALES', header.value) +
                            ') - ' +
                            $t('document.type.SALES')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'SALES', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >V</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>{{
                            "(" +
                            getNumber("SALES", header.value) +
                            ") - " +
                            $t("document.type.SALES")
                        }}</span>
                    </v-tooltip> -->
                </v-col>
                <v-col class="ma-0 d-flex justify-center" v-if="optionContain('PAY_SLIP')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'PAY_SLIP', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'PAY_SLIP', header.value)"
                        v-tooltip:bottom="
                            '(' +
                            getNumber('PAY_SLIP', header.value) +
                            ') - ' +
                            $t('document.type.PAY_SLIP')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'PAY_SLIP', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >P</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>{{
                            "(" +
                            getNumber("PAY_SLIP", header.value) +
                            ") - " +
                            $t("document.type.PAY_SLIP")
                        }}</span>
                    </v-tooltip> -->
                </v-col>
                <v-col class="ma-0 d-flex justify-center" v-if="optionContain('VAT')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'VAT', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'VAT', header.value)"
                        v-tooltip:bottom="
                            '(' + getNumber('VAT', header.value) + ') - ' + $t('document.type.VAT')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'VAT', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >T</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>{{
                            "(" + getNumber("VAT", header.value) + ") - " + $t("document.type.VAT")
                        }}</span>
                    </v-tooltip> -->
                </v-col>
                <v-col class="ma-0 d-flex justify-center" v-if="optionContain('BANK_TRANSACTION')">
                    <!-- <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }"> -->
                    <v-avatar
                        tile
                        :color="getColor(props.item, 'BANK_TRANSACTION', header.value)"
                        size="25"
                        class="pa-0 ma-0 avatarHover"
                        @click="onAvatarClicked(props.item, 'BANK_TRANSACTION', header.value)"
                        v-tooltip:bottom="
                            '(' +
                            getNumber('BANK_TRANSACTION', header.value) +
                            ') - ' +
                            $t('document.type.BANK_TRANSACTION')
                        "
                    >
                        <span
                            :class="
                                getColor(props.item, 'BANK_TRANSACTION', header.value) === white
                                    ? 'text-grey font-weight-bold'
                                    : 'text-white font-weight-bold'
                            "
                            >B</span
                        >
                    </v-avatar>
                    <!-- </template>
                        <span>{{
                            "(" +
                            getNumber("BANK_TRANSACTION", header.value) +
                            ") - " +
                            $t("document.type.BANK_TRANSACTION")
                        }}</span>
                    </v-tooltip> -->
                </v-col>
            </v-row>
        </td>

        <oss-dialog
            v-if="actionDialog"
            v-model="actionDialog"
            :title="'Que voulez-vous faire ?'"
            max-width="800px"
        >
            <template v-slot:actions>
                <v-row no-gutters style="min-width: 30vw">
                    <v-col cols="6" class="pr-2">
                        <v-btn-primary
                            rounded
                            block
                            @click="onDialogRedirectClicked"
                            data-cy="AccountingClientMonitoring-redirection"
                            size="x-large"
                            >Aller sur la page</v-btn-primary
                        >
                    </v-col>
                    <v-col cols="6" class="pl-2">
                        <v-btn-primary rounded block @click="onDialogIgnoreClicked" size="x-large"
                            >Ignorer</v-btn-primary
                        >
                    </v-col>
                </v-row>
            </template>
        </oss-dialog>
    </tr>
</template>
<script lang="ts">
import colors from "vuetify/lib/util/colors";
import { setCurrentCompany } from "@/services/userServices";
import moment from "moment-timezone";
import AccountingClientMonitoringServices from "@/services/accountingClientMonitoringServices";
import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";

const checkMonitoringKey = "c1b6011ebadc10242ac120002";

@Component({
    emits: ["name-clicked", "avatar-clicked", "dialog-ignore-clicked", "dialog-redirect-clicked"],
})
export class AccountingClientMonitoringProductionRow extends Vue {
    @Prop({ default: () => [] }) headers: Array<any>;
    @Prop({ default: () => ({}) }) props: { [key: string]: any };
    @Prop({ default: null }) itemValue: any;
    // @Prop({default: null}) taxesMonitoring: string | {}
    @Prop({ default: false }) showFECInfo: boolean;
    @Prop({ default: false }) hideName: boolean;
    @Prop({ default: null }) optionsSelected: any[];
    @Prop({ default: 0 }) rowPaddingPx: number;

    actionDialog = false;
    actionDate = null;
    actionType = null;

    taxesSchedule = {
        CVAE: ["06", "09"],
        IS: ["03", "06", "09", "12"],
        TVAQ: ["01", "04", "07", "10"],
        TVAS: ["07", "12"],
    };

    get options() {
        if (!this.optionsSelected) {
            return ["EXPENSE", "SALES", "PAY_SLIP", "BANK_TRANSACTION"];
        }
        return this.optionsSelected;
    }

    get company() {
        return this.props.item;
    }

    getNumber(value, type) {
        if (
            this.itemValue &&
            !!this.itemValue[value] &&
            !!this.itemValue[value][type] &&
            !!this.itemValue[value][type].count
        ) {
            if (this.itemValue[value][type].pendingValidation) {
                return (
                    this.itemValue[value][type].pendingValidation +
                    "/" +
                    this.itemValue[value][type].count
                );
            }
            return this.itemValue[value][type].count;
        }
        return 0;
    }

    getColor(company, value, type) {
        if (value === "PAY_SLIP" && company.profile && !company.profile.createPaySlip) {
            return this.white;
        }
        if (value === "VAT" && company.vatSystem && isNotSubjectToVAT(company.vatSystem)) {
            return this.white;
        }
        if (this.itemValue && this.itemValue[value] && this.itemValue[value][type]) {
            if (this.itemValue[value][type].pendingValidation) {
                return this.orange;
            }
            if (this.itemValue[value][type].auditCheckResult) {
                return this.grey;
            }
            return this.green;
        }
        return this.red;
    }

    get red() {
        return colors.red.accent1;
    }

    get green() {
        return "green";
    }

    get blue() {
        return colors.blue.lighten1;
    }

    get orange() {
        return colors.orange.lighten1;
    }

    get white() {
        return colors.grey.lighten4;
    }

    get grey() {
        return colors.grey.lighten2;
    }

    optionContain(option) {
        return !!this.options.filter((x) => x === option).length;
    }

    onNameClicked(item) {
        this.openDashboard();
        this.$emit("name-clicked", item);
    }

    onAvatarClicked(company, type, date) {
        this.getClick(company, type, date);
        this.$emit("avatar-clicked", company, type, date);
        this.actionDialog = true;
    }

    async onDialogIgnoreClicked() {
        await AccountingClientMonitoringServices.createSet(
            this.itemValue,
            this.actionType,
            this.actionDate,
            this.company.id,
        );
        this.$emit("dialog-ignore-clicked");
        this.actionDialog = false;
    }

    onDialogRedirectClicked() {
        this.redirectionAction();
        this.$emit("dialog-redirect-clicked");
    }

    getFECStatus(item) {
        if (this.itemValue && this.itemValue.fecFirstYear) {
            return "$oss-circle-check";
        }
        return "$oss-circle-uncheck";
    }

    getFECColor(item) {
        if (this.itemValue && this.itemValue.fecFirstYear) {
            return this.green;
        }
        return this.grey;
    }

    getClick(company, type, date, path: string = null) {
        this.actionType = type;
        this.actionDate = date;
        if (this.itemValue && this.itemValue[type] && this.itemValue[type][date]) {
            this.redirectionAction(!!this.itemValue[type][date].pendingValidation);
            return;
        }
        this.actionDialog = true;
    }

    async redirectionAction(
        addStatusfilter: boolean = false,
        declarationId: string = null,
        path: string = null,
    ) {
        const selectedCompany = this.company;
        await setCurrentCompany(this.$apollo, this.$store, selectedCompany, undefined, true);

        const startDate = this.actionDate + "-01";
        const endDate = moment(startDate).endOf("month").format("YYYY-MM-DD");

        if (this.actionType === "BANK_TRANSACTION") {
            this.$store.commit("clearBankTransactionFilter");
            if (addStatusfilter) {
                this.$store.commit("updateBankTransactionReconciliationStatus", "NOT_JUSTIFIED");
            }
            this.$store.commit("updateBankTransactionBeginDate", startDate);
            this.$store.commit("updateBankTransactionEndDate", endDate);

            this.$router.push({ name: "bank" });
        } else if (this.actionType === "VAT") {
            this.$router.push({ name: "taxForms" });
        } else {
            debugger;
            this.$store.commit("clearDocumentFilter");
            this.$store.commit("updateDocumentType", this.actionType);
            if (addStatusfilter) {
                this.$store.commit("updateDocumentStatus", "ANALYSED");
            }
            this.$store.commit("updateDocumentBeginDate", startDate);
            this.$store.commit("updateDocumentEndDate", endDate);
            this.$router.push({ name: "documents" });
        }
    }

    async openDashboard() {
        this.actionType = "DASHBOARD";
        this.actionDate = "";

        await setCurrentCompany(this.$apollo, this.$store, this.company, undefined, true);
        // this.$router.push({ name: "dashboard" });
        this.$router.push({ name: "companyStatusBoard" });
    }
}

export default toNative(AccountingClientMonitoringProductionRow);
</script>
<style lang="css" scoped>
.avatarHover:hover {
    margin: 20px;
    border: 2px white solid;
}
</style>
